
import Navigation from './components/navigation'
import Heroslider from './heroslider';
import Accordion from './components/accordion';
import Formloader from './components/formloader';
import Modal from './components/modal';
import Productpillar from './components/productpillar';
import Form from './components/form';
import Tracking from "./components/tracking";
import Lazy from "./components/lazy";

let AccordionObj = new Accordion();
let NavigationObj = new Navigation();
let HerosliderObj = new Heroslider();
let ModalObj = new Modal();
let ProductpillarObj = new Productpillar();
let formObj = new Form();
let trackingObj = new Tracking();
let lazyObj = new Lazy();

let orderForm;
let orderFormType;

if(orderForm = document.querySelector('.order-form')){
    
    if(orderForm.classList.contains('order-form--product')){
        orderFormType = 'product';
    }
    if(orderForm.classList.contains('order-form--offer')){
        orderFormType = 'offer';
    }
    
    let FormloaderObj = new Formloader(orderFormType);
}
